module.exports = __webpack_public_path__ + "img/kl06logo.402e04a7.png";